import React from 'react';
import { Box, Flex, Heading, Text } from 'pounceV2';
import WarningImg from 'Assets/illustrations/warning.svg';
import { LinkButtonV3 } from 'Components/buttons/LinkButton/LinkButtonV3';
import { Permission } from 'Generated/schema';
import useCheckPermissions from 'Hooks/useCheckPermissions';
import { useTheme } from '@mui/material';

interface Page5XXProps {
  title: string;
  text: React.ReactNode;
}

const Page5XXV3: React.FC<Page5XXProps> = ({ title, text }) => {
  const {
    palette: { tokens },
  } = useTheme();
  const canUserAccessSummary = useCheckPermissions(Permission.SummaryRead);

  return (
    <Flex justify="center" align="center" direction="column">
      <Box mb={10}>
        <img alt="Page crash illustration" src={WarningImg} width="auto" height={350} />
      </Box>
      <Heading variant="h2" fontWeight="medium" mb={2}>
        {title}
      </Heading>
      <Text textAlign="center" color={tokens.content.text.neutral[3]} mb={10} maxWidth={600}>
        {text}
      </Text>
      {canUserAccessSummary && <LinkButtonV3 to="/">Back to somewhere stable</LinkButtonV3>}
    </Flex>
  );
};

export default Page5XXV3;
